import gql from 'graphql-tag';

export default gql`
	mutation RemoveCreditCard($cardId: ID!) {
		removeCreditCard(cardId: $cardId) {
			succeed
		}
	}
`;
